import { FlagType } from '~/flags/flags';
import { getFlag, useFlag } from '~/flags/useFlag';

/** Whether the sidebar nav is enabled, either as an opt-in or as the only nav. */
export function useIsSidebarNavAvailable() {
  const hasSidebarNav = useFlag(FlagType.SidebarNav);
  const hasSidebarNavOnly = useFlag(FlagType.SidebarNavOnly);
  return Boolean(hasSidebarNav || hasSidebarNavOnly);
}

/** Non-React counterpart of `useIsSidebarNavAvailable`. */
export function getIsSidebarNavAvailable() {
  return Boolean(
    getFlag(FlagType.SidebarNav) || getFlag(FlagType.SidebarNavOnly),
  );
}
